import {
  HttpApiEndpoint,
  HttpApiError,
  HttpApiGroup,
  HttpApiSchema,
} from "@effect/platform";
import { Schema } from "effect";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import {
  openStreamSessionResponseSchema,
  streamControlInputSchema,
  streamControlSuccessSchema,
} from "../models/stream-schemas";
import { zodToEffectSchema } from "../models/zod";

export const StreamGroup = HttpApiGroup.make("stream")
  .add(
    HttpApiEndpoint.get("subscribeTeamNotifications", "/team/notifications")
      .middleware(Authorization)
      .setUrlParams(
        Schema.Struct({
          topics: Schema.optionalWith(Schema.String, { default: () => "" }),
        }),
      )
      .addSuccess(
        Schema.String.pipe(
          HttpApiSchema.withEncoding({
            kind: "Text",
            contentType: "text/event-stream",
          }),
        ),
      )
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.post("openTeamStream", "/team/stream")
      .middleware(Authorization)
      .addSuccess(zodToEffectSchema(openStreamSessionResponseSchema))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get("connectTeamStream", "/team/stream/:sessionId")
      .middleware(Authorization)
      .setPath(Schema.Struct({ sessionId: Schema.String }))
      .addSuccess(
        Schema.String.pipe(
          HttpApiSchema.withEncoding({
            kind: "Text",
            contentType: "text/event-stream",
          }),
        ),
      )
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.post("controlTeamStream", "/team/stream/:sessionId")
      .middleware(Authorization)
      .setPath(Schema.Struct({ sessionId: Schema.String }))
      .setPayload(zodToEffectSchema(streamControlInputSchema))
      .addSuccess(zodToEffectSchema(streamControlSuccessSchema))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api/streams");
